import styled from "styled-components";

export const Container = styled.section`
	@media screen and (min-width: 0px) {
		min-height: calc(100vh - 90px);
		flex: 1 1 auto;
		padding: 0;
		display: flex;
		flex-direction: column;

		header {
			flex: 1 1 auto;

			img {
				height: 100%;
				object-fit: cover;
			}
		}

		.wellcome {
			flex: 1 1 auto;
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;
			background-color: var(--primary-color);

			p,
			strong {
				color: var(--white);
			}

			.helloUser {
				text-align: center;
				max-width: 176px;
				display: block;
				margin: 1em auto;
				/* margin-bottom: 2.5em; */
				span {
					color: var(--white);
					text-transform: uppercase;
				}
			}

			.list-pets {
				padding: 0;
				list-style: none;
				display: flex;
				align-items: center;
				justify-content: center;
				column-gap: 2em;

				li a {
					display: flex;
					flex-direction: column;
					align-items: center;
					text-decoration: none;

					span {
						font-weight: 600;
						margin-top: 15px;
						border: 1px solid var(--white);
					}
				}
			}
		}
	}

	@media screen and (min-width: 992px) {
		flex-direction: row;

		header {
			flex-basis: 50%;
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;

			img {
				max-width: 414px;
				max-height: 382px;
			}
		}

		.wellcome {
			flex-basis: 50%;
			/* background-image: url(${require("../../../assets/img/labyes.png")
				.default});
			background-repeat: no-repeat;
			background-position: right bottom; */

			.helloUser {
				max-width: 372px;
				font-size: 1.5em;
			}

			.list-pets {
				li a {
					img {
						width: 100px;
						height: 100px;
					}

					p {
						max-width: 190px;
						text-align: center;
						font-size: 1.625em;
					}
				}
			}
		}
	}
`;
